import { Button } from '../Button';
import { formatCurrency } from '../../utils/formatCurrency';
import { FooterBar, FooterLeft, FooterTitle, FooterTotal } from './StickyFooter.styles';
import type { StickyFooterProps } from './StickyFooter.types';

export function StickyFooter({
  title,
  totalLabel = 'Total',
  totalAmount,
  currencyCode,
  locale = 'en-GB',
  ctaLabel,
  onCtaClick,
  ctaDisabled,
  align,
}: StickyFooterProps) {
  const formattedTotal = formatCurrency(totalAmount, currencyCode, { locale });

  return (
    <FooterBar $align={align}>
      <FooterLeft>
        <FooterTitle>{title}</FooterTitle>
        <FooterTotal>{`${totalLabel} ${formattedTotal}`}</FooterTotal>
      </FooterLeft>
      <Button variant="primary" size="medium" onClick={onCtaClick} disabled={ctaDisabled}>
        {ctaLabel}
      </Button>
    </FooterBar>
  );
}
